import styled from 'styled-components';
import { ContainerBaseModalComment } from '../styles';

export const Container = styled(ContainerBaseModalComment)``;

export const AreaText = styled.div`
  display: inline-block;
  background: #ebeef9;
  color: ${({ theme }) => theme.icon};
  padding: 1rem 0.4rem;
  border-radius: 6px;
  width: 100%;
`;

